import { Box, Button } from "@mui/material";

import { Celebration } from "../../assets/";
import { styled } from "@mui/material/styles";

export const CelebrationIcon = styled(Celebration)(({ theme }) => ({
  width: "10vh",
  height: "auto",
}));

export const ModalTitleContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

export const ConfirmButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));
